const StepEnum = {
  CHATBOT_NAME: 0,
  KNOWLEDGE: 1,
  PERSONALITY_CREATE: 2,
  REVIEW_CREATE: 3,
  PERSONALITY_CUSTOMIZE: 4,
  SETUP: 5,
  STYLING: 6,
  POWER_UPS: 7,
  TABS: 8,
  REVIEW_CUSTOMIZE: 9,
  VOICE_NAME: 10,
  CHATBOT_SELECTION: 11,
  VOICE_MODE: 12,
  VOICE_TO_TEXT: 13,
  LLM: 14,
  TEXT_TO_VOICE: 15,
  AI_VOICE: 16,
  GREETING_MESSAGE: 17,
  PERSONALITY_PROMPT: 18,
  PHONE_NUMBERS: 19
};

export { StepEnum };
